<app-recurring-payment-status-card
  *ngIf="currentUserRecurringPayment.isAffiliated || currentUserRecurringPayment.isProcessingRequest"
  class="tw-block tw-mb-6" [userRecurringPayments]="currentUserRecurringPayment"></app-recurring-payment-status-card>
<app-recurring-payment-info class="tw-block tw-mb-6" [userRecurringPayments]="currentUserRecurringPayment"></app-recurring-payment-info>

